import moment from 'moment-timezone';

export interface Day {
  date: Date;
  dayOfMonth: number;
  isWeekendDay: boolean;
  isPreviousMonth: boolean;
  isNextMonth: boolean;
  isToday: boolean;
}

export function getWeeks(date: Date) {
  if (!date) {
    throw new Error('A date is required');
  } else if (!moment(date).isValid()) {
    throw new Error('Invalid date');
  }

  const daysInMonth = moment(date).daysInMonth();
  const day = moment(date).startOf('month');
  let offset = day.day();
  const numOfWeeks = Math.ceil((daysInMonth + offset) / 7);
  const weeks: Day[][] = Array.apply(null, {
    length: numOfWeeks,
  } as any).map(() => []);
  const current = new Date();

  const [firstWeek] = weeks;
  for (let i = offset; i > 0; i--) {
    const offsetDay = day.clone().subtract(i, 'd');
    firstWeek.push({
      date: offsetDay.toDate(),
      dayOfMonth: offsetDay.date(),
      isWeekendDay: offsetDay.isoWeekday() > 5,
      isPreviousMonth: true,
      isNextMonth: false,
      isToday: false,
    });
  }

  for (let i = 0, week = weeks[i]; i < numOfWeeks; i++, week = weeks[i]) {
    for (let dayOfWeek = offset; dayOfWeek < 7; dayOfWeek++) {
      week.push({
        date: day.toDate(),
        dayOfMonth: day.date(),
        isPreviousMonth: false,
        isToday: day.isSame(current, 'day'),
        isNextMonth: !day.isSame(date, 'month'),
        isWeekendDay: day.isoWeekday() > 5,
      });
      day.add(1, 'd');
    }
    offset = 0;
  }

  return weeks;
}
